"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NocoJobsService", {
    enumerable: true,
    get: function() {
        return NocoJobsService;
    }
});
const _common = require("@nestjs/common");
const _jobslogservice = require("~/modules/jobs/jobs/jobs-log.service");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let NocoJobsService = class NocoJobsService {
    get jobsQueue() {
        return this.jobsService.jobsQueue;
    }
    async add(name, data, options) {
        return this.jobsService.add(name, data, options);
    }
    async getJob(jobId) {
        return this.jobsQueue.getJob(jobId);
    }
    async getJobStatus(jobId) {
        return this.jobsService.jobStatus(jobId);
    }
    async getJobList() {
        return this.jobsService.jobList();
    }
    async pauseQueue() {
        return this.jobsService.pauseQueue();
    }
    async resumeQueue() {
        return this.jobsService.resumeQueue();
    }
    async toggleQueue() {
        return this.jobsService.toggleQueue();
    }
    constructor(jobsService, jobsLogService){
        this.jobsService = jobsService;
        this.jobsLogService = jobsLogService;
        this.logger = new _common.Logger(NocoJobsService.name);
    }
};
NocoJobsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _jobslogservice.JobsLogService === "undefined" ? Object : _jobslogservice.JobsLogService
    ])
], NocoJobsService);
